import { Messager } from "@/assets/js/messaging.js";
import { idyuNotifyMessage, idyuRequireNotifyPermission } from "@/assets/js/idyu/notify.js";
import { RtcManager } from "@/assets/js/rtc.js";

import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import { urlBase64ToUint8Array } from "@/assets/js/idyu/util.js";
import Vue from "vue";

let audio = new Audio("/assets/sound/message.mp3");
async function initMessager(store, profile, router) {
  const messager = new Messager(profile);

  store.commit("setMessager", messager);
  await messager.connect();
  await idyuRequireNotifyPermission();
  messager.addListener({
    messageReceived: function(msg) {
      if (msg.data.type === "message") {
        if (store.state.user.messageBell) {
          audio.play();
        }
        idyuNotifyMessage(msg);
      }
    }
  });

  /*
  messager.rtcListener = function(type, track) {
    if (type == "init") {
      store.state.videoStream = new MediaStream();
    }
    if (type == "track") {
      store.state.videoStream.addTrack(track);
      router.push({ name: "Admin" });
    }
  };
*/
  let rtcManager = new RtcManager(messager, profile);
  rtcManager.onTrack = track => {
    router.push({
      name: "Admin",
      params: {
        track: track
      }
    });
  };
  messager.addRtcListener(rtcManager);
  Vue.prototype.$rtc = rtcManager;
}

export async function initPush(usr) {
  if ("serviceWorker" in navigator) {
    let reg = await navigator.serviceWorker.getRegistration();
    if (!reg) {
      return;
    }

    const publicKey = "BGTKmeEYmcGrwcBGZwWxLaIfTDNdqHTCNgMjh0AYeaDvrRPC63p2RzWvX3XXxcKJdpIvujfYU751CdLSZICBYDg";
    const convertedVapidKey = urlBase64ToUint8Array(publicKey);

    let sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey
    });

    var key = sub.getKey("p256dh");
    var auth = sub.getKey("auth");
    var b64Key = btoa(String.fromCharCode.apply(null, new Uint8Array(key)));
    var b64auth = btoa(String.fromCharCode.apply(null, new Uint8Array(auth)));

    if (sub.endpoint != usr.pushEndpoint) {
      await idyuJsonRpc("pushSubscribe", sub.endpoint, b64Key, b64auth);
      usr.pushEndpoint = sub.endpoint;
      usr.pushKey = b64Key;
      usr.b64auth = b64auth;
    }
  }
}

export async function idyuInit(store, res, router) {
  store.commit("setData", res.data);
  store.commit("setProfile", res.profile);
  store.commit("setUser", res.user);

  if (localStorage["icon-theme"]) store.commit("setIconTheme", localStorage["icon-theme"]);
  if (localStorage["show-version"]) store.commit("setShowVersion", localStorage["show-version"]);
  initMessager(store, res.profile, router);

  // Init Bandeau
  let bandeau = 0;
  try {
    bandeau = await idyuJsonRpc("getPassLinkType");
  } catch {
    //
  }
  store.commit("setPassLinkType", bandeau);
  store.commit("updateBandeau");

  try {
    initPush(res.user);
  } catch {
    console.log("Could not init push manager");
  }
}
